module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Back","selectMessage":"Select a restaurant to view its details"},"es":{"back":"Atrás","selectMessage":"Elige un restaurante para ver sus detalles"}}')
  delete Component.options._Ctor
}
